import { render, staticRenderFns } from "./DashboardNoPage.vue?vue&type=template&id=6715cb2f"
import script from "./DashboardNoPage.vue?vue&type=script&lang=js"
export * from "./DashboardNoPage.vue?vue&type=script&lang=js"
import style0 from "./DashboardNoPage.vue?vue&type=style&index=0&id=6715cb2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports